import { CompanyInfo } from "@/models/companyInfo";
import { Address } from "@/models/address";
import type { RiskStatsDto } from "./dto/riskStatsDto";
import type { QuestionnaireResponseSummary } from "@/models/questionnaireResponseSummary";
import { ContactInfo } from "@/models/contactInfo";

export class UnitProfile {
  basicCompanyInfo: CompanyInfo = new CompanyInfo();
  tierLevel: number = 0;
  companyAddress: Address = new Address();
  risks: RiskStatsDto[] = [] as RiskStatsDto[];
  questionnaireResponses: QuestionnaireResponseSummary[] = new Array<QuestionnaireResponseSummary>();
  countriesOfOperation: string[] = new Array<string>();
  contactPerson: ContactInfo = new ContactInfo();
}
